import { useContext } from 'react';
import { createContext } from 'react';

import { ModalHeaderProps } from '../@types/ModalHeaderProps';

export const ModalHeaderContext = createContext<ModalHeaderProps>({} as ModalHeaderProps);

ModalHeaderContext.displayName = 'ModalHeader';

const ModalHeaderProvider = (props: ModalHeaderProps) => (
	<ModalHeaderContext.Provider value={props}>{props.children}</ModalHeaderContext.Provider>
);

export const useModalHeader = () => {
	const context = useContext(ModalHeaderContext);

	return context;
};

export default ModalHeaderProvider;
